import { NInput } from '@innersource-nn/novoui-react';
import React, { useEffect, useState, useCallback } from 'react';

interface SearchBarProps {
    term: string;
    onTermChange: (term: string) => void;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
    debounceTime?: number;
}

const SearchBar = ({
    term,
    onTermChange,
    placeholder,
    className,
    disabled,
    debounceTime = 300,
}: SearchBarProps) => {
    const [debouncedTerm, setDebouncedTerm] = useState(term);

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setDebouncedTerm(e.target.value);
        },
        [],
    );

    useEffect(() => {
        setDebouncedTerm(term);
    }, [term]);

    useEffect(() => {
        const handler = setTimeout(() => {
            if (debouncedTerm !== term) {
                onTermChange(debouncedTerm);
            }
        }, debounceTime);

        return () => {
            clearTimeout(handler);
        };
    }, [debouncedTerm, debounceTime, onTermChange, term]);

    return (
        <NInput
            className={className}
            modelValue={debouncedTerm}
            onChange={handleChange}
            placeholder={placeholder ?? 'Search...'}
            disabled={disabled}
            variant="outline-light"
        />
    );
};

export default SearchBar;
